module.exports = __webpack_public_path__ + "static/media/photo3.6847f99b.jpg";